(function () {
  var CFG = {
    companyId: 'SNctWk',
    listId:    'WZZ6mW',
    revision:  '2026-07-15',
    code:      'WELCOME10',
    revealPct: 5,
    delayMs:   3000,
    seenKey:   'uts.seen.v1',
    stateKey:  'uts.state.v1',
    pillKey:   'uts.pill.v1',
    skip:      ['/cart', '/checkout', '/challenge', '/account', '/tools', '/policies'],
    ageKey:    'bc_age_verified_at',
    ageMaxMs:  30 * 24 * 60 * 60 * 1000,
    fonts:     'https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@700&family=Archivo:wght@400;500&family=Courier+Prime&display=swap'
  };

  var root = document.getElementById('uts');
  if (!root) return;

  var PREVIEW = /[?&]uts=1\b/.test(location.search);

  function skipsPath() {
    var p = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
    for (var i = 0; i < CFG.skip.length; i++) {
      var s = CFG.skip[i];
      if (p === s || p.indexOf(s + '/') === 0) return true;
    }
    return false;
  }
  function seen() {
    try { return localStorage.getItem(CFG.seenKey) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { localStorage.setItem(CFG.seenKey, '1'); } catch (e) {}
  }
  function getState() {
    try { return localStorage.getItem(CFG.stateKey) || 'new'; } catch (e) { return 'new'; }
  }
  function setState(v) {
    try { localStorage.setItem(CFG.stateKey, v); } catch (e) {}
  }
  function pillDismissed() {
    try { return localStorage.getItem(CFG.pillKey) === '1'; } catch (e) { return false; }
  }

  // Only a skipped path bails outright. A visitor who dismissed the takeover
  // still gets the pill, which is their way back in.
  if (!PREVIEW && skipsPath()) return;

  var panes = {}, current = null;
  [].forEach.call(root.querySelectorAll('.uts-pane'), function (el) {
    panes[el.getAttribute('data-pane')] = el;
  });

  // One source of truth for the number, so the strip and the config cannot drift.
  (function () {
    var amt = document.getElementById('uts-amt');
    if (amt) amt.innerHTML = CFG.revealPct + '<i>%</i> off';
  })();

  function show(name) {
    if (current) current.classList.remove('on');
    current = panes[name];
    current.classList.add('on');
    var f = current.querySelector('input, button:not([data-uts-close]), a');
    if (f && name !== 'scratch') { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }

  var canvas = document.getElementById('uts-strip');
  var plate  = document.getElementById('uts-plate');
  var ctx    = canvas.getContext('2d');
  var spent  = false;

  function paintStrip() {
    var r = plate.getBoundingClientRect();
    if (!r.width) return false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width  = Math.round(r.width * dpr);
    canvas.height = Math.round(r.height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var w = r.width, h = r.height;

    // A bonded tax strip is printed flat. No gradient, no sheen.
    ctx.fillStyle = '#7A2430';
    ctx.fillRect(0, 0, w, h);

    // Uneven ink take, the way a real strip absorbs unevenly.
    for (var i = 0; i < 1400; i++) {
      ctx.fillStyle = 'rgba(0,0,0,' + (Math.random() * 0.06) + ')';
      var s = Math.random() * 2.2;
      ctx.fillRect(Math.random() * w, Math.random() * h, s, s);
    }
    for (var j = 0; j < 260; j++) {
      ctx.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.045) + ')';
      ctx.fillRect(Math.random() * w, Math.random() * h, Math.random() * 1.6, Math.random() * 1.6);
    }

    ctx.strokeStyle = 'rgba(232,223,206,.34)';
    ctx.lineWidth = 1;
    ctx.strokeRect(6.5, 6.5, w - 13, h - 13);

    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'rgba(232,223,206,.9)';
    ctx.font = "700 " + Math.round(h * 0.19) + "px 'Saira Condensed','Arial Narrow',Arial,sans-serif";
    ctx.fillText('BONDED', 22, h * 0.34);

    ctx.fillStyle = 'rgba(232,223,206,.62)';
    ctx.font = "10px 'Courier Prime','Courier New',monospace";
    ctx.fillText('DO NOT REMOVE UNTIL SOLD', 22, h * 0.58);
    ctx.fillStyle = 'rgba(232,223,206,.42)';
    ctx.fillText('SER. 0338-H-7', 22, h * 0.76);

    return true;
  }

  var lastPt = null;

  // A round-capped line from the previous sample, not an isolated dot: pointermove
  // only fires every few pixels, so arcs alone leave gaps on a fast swipe.
  function scratchAt(x, y) {
    if (spent) return;
    ctx.globalCompositeOperation = 'destination-out';
    // destination-out removes destination alpha in proportion to SOURCE alpha,
    // so the brush must be fully opaque. paintStrip leaves strokeStyle at .34
    // and fillStyle at .42, which erased only a third of the strip per pass and
    // meant clearedFraction() could never cross the reveal threshold.
    ctx.strokeStyle = '#000';
    ctx.fillStyle = '#000';
    if (lastPt) {
      ctx.lineWidth = 42;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(lastPt.x, lastPt.y);
      ctx.lineTo(x, y);
      ctx.stroke();
    } else {
      ctx.beginPath();
      ctx.arc(x, y, 21, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalCompositeOperation = 'source-over';
    lastPt = { x: x, y: y };
  }

  function clearedFraction() {
    var w = canvas.width, h = canvas.height;
    if (!w || !h) return 0;
    var d;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { return 0; }
    var clear = 0, total = 0;
    for (var i = 3; i < d.length; i += 4 * 24) { total++; if (d[i] < 40) clear++; }
    return total ? clear / total : 0;
  }

  function reveal() {
    if (spent) return;
    spent = true;
    canvas.classList.add('spent');
    document.getElementById('uts-hinttext').textContent = 'Nice.';
    document.getElementById('uts-reveal').hidden = true;
    setState('reveal');
    setTimeout(function () { show('email'); }, 850);
  }

  var drawing = false;
  var touched = false;
  function localPoint(ev) {
    var r = canvas.getBoundingClientRect();
    return { x: ev.clientX - r.left, y: ev.clientY - r.top };
  }
  canvas.addEventListener('pointerdown', function (ev) {
    if (spent) return;
    drawing = true;
    touched = true;
    lastPt = null;
    try { canvas.setPointerCapture(ev.pointerId); } catch (e) {}
    var p = localPoint(ev); scratchAt(p.x, p.y);
    ev.preventDefault();
  });
  canvas.addEventListener('pointermove', function (ev) {
    if (!drawing || spent) return;
    var p = localPoint(ev); scratchAt(p.x, p.y);
    ev.preventDefault();
  });
  function endStroke() {
    if (!drawing) return;
    drawing = false;
    lastPt = null;
    if (clearedFraction() > 0.5) reveal();
  }
  canvas.addEventListener('pointerup', endStroke);
  canvas.addEventListener('pointercancel', endStroke);
  canvas.addEventListener('pointerleave', endStroke);

  // Keyboard and assistive path: no drag required.
  document.getElementById('uts-reveal').addEventListener('click', reveal);

  function subscribe(attrs) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CFG.companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': CFG.revision },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Under the Strip popup',
            profile: { data: { type: 'profile', attributes: attrs } }
          },
          relationships: { list: { data: { type: 'list', id: CFG.listId } } }
        }
      })
    }).then(function (res) {
      if (res.status === 202 || res.ok) return true;
      return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ' ' + t); });
    });
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  // US number to E.164. Klaviyo rejects anything else.
  function toE164(v) {
    var d = (v || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10) return null;
    return '+1' + d;
  }

  var savedEmail = null;

  document.getElementById('uts-email-form').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var input = document.getElementById('uts-email');
    var err   = document.getElementById('uts-email-err');
    var v     = input.value.trim();
    if (!validEmail(v)) { err.textContent = 'That address does not look right.'; input.focus(); return; }
    err.textContent = '';
    var btn = this.querySelector('button');
    btn.disabled = true; btn.textContent = 'Sending';
    subscribe({
      email: v,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    }).then(function () {
      savedEmail = v;
      markSeen();
      setState('done');
      show('sms');
    })['catch'](function (e) {
      err.textContent = 'That did not go through. Try once more.';
      if (window.console) console.error('[under-the-strip]', e);
    })['finally'](function () {
      btn.disabled = false; btn.textContent = 'Send it';
    });
  });

  document.getElementById('uts-sms-form').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var input = document.getElementById('uts-phone');
    var err   = document.getElementById('uts-sms-err');
    var e164  = toE164(input.value);
    if (!e164) { err.textContent = 'Enter a 10-digit US mobile number.'; input.focus(); return; }
    err.textContent = '';
    var btn = this.querySelector('button');
    btn.disabled = true; btn.textContent = 'Sending';
    var attrs = {
      phone_number: e164,
      subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (savedEmail) attrs.email = savedEmail;
    subscribe(attrs).then(function () {
      document.getElementById('uts-done-sub').textContent =
        'Use it whenever, it does not expire. Check your texts to confirm the number.';
      show('done');
    })['catch'](function (e) {
      err.textContent = 'That number did not go through. Try again or skip.';
      if (window.console) console.error('[under-the-strip]', e);
    })['finally'](function () {
      btn.disabled = false; btn.textContent = 'Text me';
    });
  });

  document.getElementById('uts-skip-sms').addEventListener('click', function () { show('done'); });

  document.getElementById('uts-copy').addEventListener('click', function () {
    var btn = this;
    var done = function () { btn.textContent = 'Copied'; setTimeout(function(){ btn.textContent = 'Copy'; }, 1600); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(CFG.code).then(done)['catch'](function(){});
    } else {
      var t = document.createElement('textarea');
      t.value = CFG.code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(t);
    }
  });

  var lastFocus = null;
  var scrollLocked = false;

  function close() {
    root.hidden = true;
    if (scrollLocked) { document.documentElement.style.overflow = ''; scrollLocked = false; }
    markSeen();
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    showPill();
  }

  function onKey(ev) {
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key !== 'Tab') return;
    var f = root.querySelectorAll('.uts-pane.on a[href], .uts-pane.on button:not([hidden]), .uts-pane.on input, .uts-x');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  }

  [].forEach.call(root.querySelectorAll('[data-uts-close]'), function (b) {
    b.addEventListener('click', close);
  });

  function open(pane) {
    hidePill();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    scrollLocked = true;
    show(pane || 'scratch');
    // Measure only once attached, or the plate has no width yet.
    if (!paintStrip()) {
      requestAnimationFrame(function () { if (!paintStrip()) requestAnimationFrame(paintStrip); });
    }
    document.addEventListener('keydown', onKey, true);
  }

  // Repaint on resize, but never wipe a strip already scratched or spent.
  var rt;
  window.addEventListener('resize', function () {
    if (root.hidden || spent || touched) return;
    clearTimeout(rt);
    rt = setTimeout(function () { paintStrip(); }, 180);
  });

  // Fonts load only when the popup is actually going to appear, so every other
  // page view pays nothing for them.
  function loadFonts() {
    if (document.querySelector('link[data-uts-fonts]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CFG.fonts; l.setAttribute('data-uts-fonts', '1');
    document.head.appendChild(l);
  }

  var pill      = document.getElementById('uts-pill');
  var pillLabel = document.getElementById('uts-pill-label');

  // Return someone to the step they actually reached, rather than making them
  // scratch a strip that is already spent.
  function pillTarget() {
    var st = getState();
    if (st === 'done')   return 'done';
    if (st === 'reveal') return 'email';
    return 'scratch';
  }

  function hidePill() { if (pill) pill.hidden = true; }

  // Emotive's teaser floater owns left:16 bottom:16. Rather than sit underneath
  // it, measure it and stack above it.
  function placePill() {
    if (!pill) return;
    pill.style.bottom = '';
    var em = document.getElementById('emotive-popup-teaser-floater');
    if (!em) return;
    var r = em.getBoundingClientRect();
    if (r.width < 20 || r.height < 12) return;
    var fromBottom = window.innerHeight - r.bottom;
    if (r.left > window.innerWidth * 0.5 || fromBottom > 140) return;
    pill.style.bottom = Math.round(fromBottom + r.height + 12) + 'px';
  }

  function showPill() {
    if (!pill || pillDismissed() || skipsPath()) return;
    var st = getState();
    pillLabel.textContent = st === 'done'   ? 'Your code'
                          : st === 'reveal' ? 'Finish claiming'
                          : 'Get up to 10% off';
    pill.hidden = false;
    placePill();
  }

  if (pill) {
    document.getElementById('uts-pill-open').addEventListener('click', function () {
      open(pillTarget());
    });
    document.getElementById('uts-pill-dismiss').addEventListener('click', function () {
      try { localStorage.setItem(CFG.pillKey, '1'); } catch (e) {}
      hidePill();
    });
    window.addEventListener('resize', function () { if (!pill.hidden) placePill(); });
    // Emotive injects late, so re-measure once it has had time to land.
    setTimeout(function () { if (pill && !pill.hidden) placePill(); }, 4000);
  }

  function arm() {
    loadFonts();
    if (PREVIEW) { open(); return; }
    setTimeout(function () { open(); }, CFG.delayMs);
  }

  // Inert unless snippets/age-gate.liquid is rendering. Kept so that re-adding
  // an age gate later cannot stack this takeover behind it: the delay would
  // otherwise expire while the gate is up, putting the popup on screen the
  // instant someone confirms their age.
  function ageVerified() {
    if (!document.getElementById('bc-age-gate')) return true;
    try {
      var v = localStorage.getItem(CFG.ageKey);
      if (!v) return false;
      var elapsed = Date.now() - parseInt(v, 10);
      return !isNaN(elapsed) && elapsed < CFG.ageMaxMs;
    } catch (e) {
      return false;
    }
  }

  function armWhenAllowed() {
    if (PREVIEW || ageVerified()) { arm(); return; }

    var gate = document.getElementById('bc-age-gate');
    var fired = false;
    var mo = null;
    var iv = null;

    function go() {
      if (fired) return;
      fired = true;
      if (mo) mo.disconnect();
      if (iv) clearInterval(iv);
      arm();
    }

    // Mirror the gate's own localStorage condition rather than reading its
    // hidden attribute: both scripts run on DOMContentLoaded and the order is
    // not guaranteed, so the attribute can be read before the gate opens.
    if (window.MutationObserver && gate) {
      mo = new MutationObserver(function () { if (ageVerified()) go(); });
      mo.observe(gate, { attributes: true, attributeFilter: ['hidden', 'class'] });
    }
    iv = setInterval(function () { if (ageVerified()) go(); }, 400);
  }

  function start() {
    // Already dismissed: no takeover, just the way back in.
    if (!PREVIEW && seen()) { showPill(); return; }
    armWhenAllowed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
